//Mahesh S : 17-08-2023 : BT-107431 - Breeze - Watchlist Side Tray - Orders, Positions & Holdings- Start
import { memo, useEffect, useMemo, useState } from 'react';
import ContainerBody from '../ContainerBody';
import ContainerHeader from '../ContainerHeader';
import { BzTabsContainer, BzToolTip } from '../../../../components';
import { Container, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from 'react-redux';
import { FACILITY_NUM, IS_MULTILEG_ALLOWED, SIDE_TRAY_EXPAND_PERCENTAGE } from '../../../../utils/global_variables';
import OrdersTabs from './OrdersTabs';
import PositionsContents from './Positions';
import { getNetPositions } from '../../../../redux/actions/netPosition';
import HoldingsContents from './Holdings';
import OrdersContents from './Orders';
import FilterOrdersPosition from './FilterOrdersPosition';
import { clearAllOpenOrders, getAllGtdOrders, updateFilters } from '../../../../redux/actions/orders';
import { handleModalData, updateModalData } from '../../../../redux/actions/modals';
import { getAllHoldingScrips } from '../../../../redux/actions/holdings';
import { isGuestUser } from '../../../../utils/global_functions';



const SideOrderPositions = ({ setIsExpanded, scripOverviewData, setToggleSideContainer, market, setMarket, handlePlaceOrder, setActiveMenu, ...props }) => {
    const dispatch = useDispatch();

    const [activeTabKey, setActiveTabKey] = useState("orders");
    const [ordersActiveTabKey, setOrdersActiveTabKey] = useState('single_scrip');
    const [positionsActiveTabKey, setPositionsActiveTabKey] = useState('todays');
    const [holdingssActiveTabKey, setHoldingssActiveTabKey] = useState('equity');
    const [showPlaceOrder, setShowPlaceOrder] = useState(true);
    const activeOrders = useSelector(state => state.orders.orderTypes);
    const gtdOrders = useSelector(state => state?.orders?.gtdOrders);
    const todaysPostions = useSelector(state => state?.netPosition?.todaysPostions);
    const overAllPositions = useSelector(state => state?.netPosition?.overAllPositions);
    const holdingsScrips = useSelector(state => state.holdings.holdingsScrips);
    const objEquitySIPMetaData = useSelector(state => state.orders.objEquitySIPMetaData);
    const objCFT = useSelector(state => state?.auth?.objCFT);
    // const spreadOrders = useMemo(() => activeOrders[1]?.data?.filter((each) => each?.orderType === 'Spread'), [activeOrders]);
    const spreadOrders = useSelector(state => state?.orders?.arrSpreadAllOrders);
    const nAllSpreadOrdersLength = useSelector(state => state?.orders?.nAllSpreadOrdersLength);
    //const { allOrders: multiLegOrders } = useSelector(state => state?.orders?.getMultiLegOrder);
    const nAllMultilegOrdersLength = useSelector(state => state?.orders?.nAllMultilegOrdersLength); //Ajitesh 15-07-2024 - Multileg Pagination for sidebar
    // const nAllMultilegOrdersLength = useMemo(() => activeOrders[1]?.data?.filter((each) => each?.orderType === "Multi Leg"), [activeOrders]);
    //Vaibhav Singh: 05-02-24: BT-107431: Added Count Logic for header tabs: Start
    const [countOrder, setCountOrder] = useState(0);
    const [countHolding, setCountHolding] = useState(0);
    const [countPosition, setCountPosition] = useState(0);
    // Vaibhav Singh: 20-02-24: Fixed issue with filter toggle: Start
    useEffect(() => {
        dispatch(updateFilters({}));
    }, [activeTabKey, dispatch]);
    // Vaibhav Singh: 20-02-24: Fixed issue with filter toggle: End
    useEffect(() => {
        if (!isGuestUser()) {
            dispatch(getNetPositions({ type: 'all', interopFlag: 1 }));
            dispatch(getAllGtdOrders({ offSet: 1, limit: 20, orderStatus: -1 }));
        }
        dispatch(updateFilters({}));
        dispatch(getAllHoldingScrips());
    }, [dispatch]);
    useEffect(() => {
        setCountOrder(~~activeOrders?.[0]?.metadata?.all_records + ~~nAllMultilegOrdersLength + ~~spreadOrders?.length + ~~gtdOrders?.length + ~~objEquitySIPMetaData?.total_records);
        setCountPosition(~~overAllPositions?.length + ~~todaysPostions?.length);
        setCountHolding(~~holdingsScrips?.length + 0);
    }, [nAllMultilegOrdersLength, gtdOrders, spreadOrders, activeOrders, holdingsScrips, todaysPostions, overAllPositions, objEquitySIPMetaData]);

    const arrPlaceOrderInfo = useMemo(() => [
        {
            id: 1,
            scrip: `Orders (${countOrder})`,
            tabKey: "orders",
        },
        {
            id: 2,
            scrip: `Positions (${countPosition})`,
            tabKey: "positions",
        },
        {
            id: 3,
            scrip: `Holdings (${countHolding})`,
            tabKey: 'holdings',
        }
    ], [countHolding, countOrder, countPosition]);
    //Vaibhav Singh: 05-02-24: BT-107431: Added Count Logic for header tabs: End

    // Vinit Raut : 23-02-2024 : BT-127175 - Breeze – Bug fixes -- Start
    const handleClose = () => {
        setIsExpanded(prevState => {
            return {
                ...prevState, isTrue: false,
                containerLength: prevState?.isTrue ? SIDE_TRAY_EXPAND_PERCENTAGE?.TWENTY_FIVE_PERCENT : SIDE_TRAY_EXPAND_PERCENTAGE?.ZERO_PERCENT
            };
        });
        setToggleSideContainer(false);
        setActiveMenu({});
        dispatch(clearAllOpenOrders());
    };
    // Vinit Raut : 23-02-2024 : BT-127175 - Breeze – Bug fixes -- End

    useEffect(() => {
        dispatch(handleModalData({ filter: {} }));
        dispatch(updateFilters({}));
    }, [ordersActiveTabKey, dispatch, activeTabKey]);
    return (
        <>
            <>
                {showPlaceOrder && <>
                    <ContainerHeader>
                        <Container fluid className='p-0'>
                            <Row className='g-0 stickysidemenu-top-header bdr-btm p-3'>
                                <Col md={10} className='d-flex justify-content-start align-self-center'>
                                    <div className='font-medium font-size5 color-text text-uppercase'>ORDERS</div>
                                    {props.children}
                                </Col>
                                <Col md={2} className='d-flex justify-content-end align-self-center'>
                                    <BzToolTip placement={'bottom'} TooltipMsg={'Close'}>
                                        <div className='icon-16 icon-dark icon-close' onClick={handleClose}></div>
                                    </BzToolTip>
                                </Col>
                            </Row>
                            <Row className='g-0 mt-2 px-3'>
                                <Col md={12} className='d-flex justify-content-start align-self-center'>
                                    <OrdersTabs arrPlaceOrderInfo={arrPlaceOrderInfo} activeTabKey={activeTabKey} setActiveTabKey={setActiveTabKey} />
                                </Col>
                            </Row>
                            {
                                (activeTabKey === 'orders') &&
                                <Row className='g-0 mt-2 mb-2 px-3'>
                                    <Col className='d-flex justify-content-end text-end' style={{ width: 'inhert', borderBottom: 'inherit' }}>
                                        <div className='submenu-wrapper horizontal-scroll-wrap py-1'>
                                            <div onClick={() => { setOrdersActiveTabKey('single_scrip'); }} className={`submenuItem ${ordersActiveTabKey === 'single_scrip' ? 'active' : ''}`}>Single Scrip ({activeOrders[0]?.metadata?.all_records > 0 ? activeOrders[0]?.metadata?.all_records : 0})</div>
                                            <div onClick={() => { setOrdersActiveTabKey('spread'); }} className={`submenuItem ${ordersActiveTabKey === 'spread' ? 'active' : ''}`}>Spread ({nAllSpreadOrdersLength || 0})</div>
                                            {IS_MULTILEG_ALLOWED && <div onClick={() => { setOrdersActiveTabKey('multi_Leg'); }} className={`submenuItem ${ordersActiveTabKey === 'multi_Leg' ? 'active' : ''}`}>MultiLeg ({nAllMultilegOrdersLength || 0})</div>}
                                            <div onClick={() => { setOrdersActiveTabKey('good_till_date'); }} className={`submenuItem ${ordersActiveTabKey === 'good_till_date' ? 'active' : ''}`}>{objCFT?.GTTSUPPORT === FACILITY_NUM.ON ? 'Good Till Trigger' : 'Good Till Date'}({gtdOrders?.length > 0 ? gtdOrders?.length : 0})</div>
                                            <div onClick={() => { setOrdersActiveTabKey('equity_sip'); }} className={`submenuItem ${ordersActiveTabKey === 'equity_sip' ? 'active' : ''}`}>Equity Sip ({objEquitySIPMetaData?.total_records || 0})</div>
                                        </div>
                                    </Col>
                                </Row>
                            }
                            {
                                activeTabKey === 'positions' &&
                                <Row className='g-0 mt-2 mb-2 px-3'>
                                    <Col>
                                        <div className='submenu-wrapper d-flex align-items-center'>
                                            <div onClick={() => { setPositionsActiveTabKey('todays'); dispatch(updateModalData({})); }} className={`submenuItem ${positionsActiveTabKey === 'todays' ? 'active' : ''}`}>Today's ({todaysPostions?.length})</div>
                                            <div onClick={() => { setPositionsActiveTabKey('overall'); dispatch(updateModalData({})); }} className={`submenuItem ${positionsActiveTabKey === 'overall' ? 'active' : ''}`}>Overall ({overAllPositions?.length})</div>
                                        </div>
                                    </Col>
                                </Row>
                            }
                            {
                                activeTabKey === 'holdings' &&
                                <Row className='g-0 mt-2 mb-4 px-3'>
                                    <Col>
                                        <div className='submenu-wrapper d-flex align-items-center'>
                                            {/*   Vaibhav Singh: 05-02-24: BT-107431: Added Count Logic for header tabs: Start */}
                                            <div onClick={() => { setHoldingssActiveTabKey('equity'); }} className={`submenuItem ${holdingssActiveTabKey === 'equity' ? 'active' : ''}`}>Equity ({~~holdingsScrips?.length})</div>
                                            <div onClick={() => { setHoldingssActiveTabKey('mutual_funds'); }} className={`submenuItem ${holdingssActiveTabKey === 'mutual_funds' ? 'active' : ''}`}>Mutual Funds (0)</div>
                                            {/*   Vaibhav Singh: 05-02-24: BT-107431: Added Count Logic for header tabs: End */}
                                        </div>
                                    </Col>
                                </Row>
                            }

                        </Container>
                    </ContainerHeader>
                </>}

                <ContainerBody>
                    <BzTabsContainer>
                        {activeTabKey === 'orders' && <OrdersContents ordersActiveTabKey={ordersActiveTabKey} />}
                        {activeTabKey === 'positions' && <PositionsContents positionsActiveTabKey={positionsActiveTabKey} />}
                        {activeTabKey === 'holdings' && <HoldingsContents holdingssActiveTabKey={holdingssActiveTabKey} />}
                    </BzTabsContainer>
                </ContainerBody>

                <FilterOrdersPosition activeTabKey={activeTabKey} />
            </>


        </>
    );
};

export default memo(SideOrderPositions);

//Mahesh S : 17-08-2023 : BT-107431 - Breeze - Watchlist Side Tray - Orders, Positions & Holdings- End
